import AdminToolbar, {
  AdminButton,
} from '@rover/react-lib/src/components/AdminToolbar/AdminToolbar';
import useLocationContext from '@rover/react-lib/src/context/useLocationContext';
import { useApiCommerceOrderAdminToolbarViewRetrieve } from '@rover/rsdk/src/apiClient/latest';

const ORDER_OPK_REGEX = /checkout\/([^/]+)\//;

function extractOrderOpkFromPathname(pathname: string): string | null {
  return pathname.match(ORDER_OPK_REGEX)?.[1] ?? null;
}

export const CommerceAdminToolbar = (): JSX.Element => {
  const { pathname } = useLocationContext();
  const orderOpk = extractOrderOpkFromPathname(pathname);
  const { isLoading, data } = useApiCommerceOrderAdminToolbarViewRetrieve(orderOpk!, {
    query: { enabled: !!orderOpk },
  });

  return (
    <AdminToolbar>
      {/* Render empty span when loading to prevent flashing */}
      {isLoading ? (
        <span />
      ) : (
        data?.buttons.map((button) => (
          <AdminButton key={button.text} href={button.url}>
            {button.text}
          </AdminButton>
        ))
      )}
    </AdminToolbar>
  );
};
